import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import TopListenersChart from "./Charts/TopListener";
import MonthlyListenersChart from "./Charts/MonthlyListenerChart";
import { Link } from "react-router-dom";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isToday,
  isSameMonth,
  isSameDay,
  eachDayOfInterval,
} from "date-fns";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch, useSelector } from "react-redux";
import {
  createEvent,
  fetchEventImage,
  fetchScheduleCategory,
  fetchUpcomingEvents,
  resetCreateEvent,
  uploadEventImage,
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
const DashboardRap = styled.div`
  padding,
  h1,
  h2,
  h3,
  h4 {
    margin: 0px;
  }
  .sub-dash-1 p {
    color: #363d4f;
    font-size: 400;
    font-size: 15px;
    margin: 0px;
  }
  .sub-dash-1 h4 {
    color: #060b13;
    margin: 0px;
    font-size: 600;
    font-size: 20px;
  }
  .sub-dash-1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .links {
    border-top: 1px;
    border-left: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-style: solid;
    border-color: #060b13;
    border-radius: 100px;
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    height: 44px;
  }
  .live {
    background: #ed1c24;
    width: 136px;
    color: #ffffff;
  }
  .schedule,
  .upload {
    background: #ffffff;
    width: 213px;
    color: #060b13;
  }
  .the-links {
    display: flex;
    gap: 15px;
    align-items: center;
  }
  .dash-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .dashboard {
    background: #ffffff;
    border: 1px solid #bac0d499;
    border-radius: 20px;
    padding: 30px;
    margin-right: 30px;
  }
  .sub-dash-2 {
    width: 248px;
    border-radius: 12px;
    border: 1px solid #bac0d499;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
  }
  .sub-dash-2 p {
    color: #818893;
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
  }
  .sub-dash-2 h4 {
    color: #060b13;
    font-size: 30px;
    font-weight: 700;
    display: flex;
    margin: 0px;
    width: 100%;
    align-items: center;
    justify-content: space-between !important;
  }
  .sub-dash-2 span {
    background: #ecfdf3;
    width: 66px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #027a48;
    font-size: 12px;
    font-weight: 400;
    border-radius: 16px;
  }
  .dash-2 {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 30px;
  }
  .sub-dash-3-1 {
    border: 1px solid #bac0d499;
    border-radius: 20px;
    width: 70%;
    padding: 20px;
  }
  .sub-dash-3-2 {
    width: 30%;
    padding: 20px;
    border: 1px solid #bac0d499;
    border-radius: 20px;
  }
  .top-listen-head,
  .month-listen-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .dash-3 {
    display: flex;
    gap: 15px;
    margin-top: 30px;
  }
  .event-slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    position: relative;
    width: 100%;
    max-width: 1500px;
    padding: 0 48px;
    box-sizing: border-box;
  }

  .event-container {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
    transition: transform 0.45s ease;
    will-change: transform;
  }

  .slider-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: rgba(6, 11, 19, 0.7);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
    z-index: 2;
  }

  .slider-nav:hover {
    background: rgba(6, 11, 19, 0.9);
  }

  .slider-nav.prev {
    left: 12px;
  }

  .slider-nav.next {
    right: 12px;
  }

  .slider-nav:disabled {
    opacity: 0.4;
    cursor: default;
    pointer-events: none;
  }

  .event-card {
    width: 229px;
    height: 246px;
    border-radius: 5px;
    background-size: cover;
    background-position: center;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    padding-bottom: 30px;
  }

  .event-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 20%,
      rgba(0, 0, 0, 0.65) 80%,
      #000000 100%
    );
    border-radius: 5px;
  }

  .event-content h4 {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 15px;
    text-align: center;
  }
  .event-content p {
    color: #99a2af;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }
  .event-content {
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .dots-container {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  .dot {
    height: 8px;
    width: 8px;
    margin: 5px;
    background-color: #bbb;
    border-radius: 50%;
    cursor: pointer;
  }

  .dot.active {
    background-color: #060b13;
  }
  .dash-4 {
    border: 1px solid #bac0d499;
    border-radius: 20px;
    padding: 20px;
  }
  .sub-dash-4 h4 {
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .updatesTh {
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
  }
  .name,
  .text {
    color: #060b13;
    font-size: 12px;
    font-weight: 400;
    margin: 0px;
  }
  .text {
    color: #818893;
  }
  .row-name {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .left-td {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }
  tbody tr {
    margin-bottom: 15px !important;
  }
  .time {
    color: #818893;
    font-size: 12px;
    font-weight: 400;
  }
  .dash-5 {
    border: 1px solid #bac0d499;
    padding: 20px;
    border-radius: 16px;
    width: 30%;
  }
  .all-dashes {
    display: flex;
    gap: 20px;
    margin-top: 30px;
  }
  .dash-4 {
    border: 1px solid #bac0d499;
    border-radius: 20px;
    padding: 20px;
    width: 70%;
  }
  .no-events p {
    color: #818893;
    font-weight: 400;
    font-size: 12px;
  }
  .no-events h4 {
    color: #060b13;
    font-weight: 500;
    font-size: 16px;
  }
  .no-events-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  .no-events {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    justify-content: center;
    height: 100%;
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
    right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input,
  textarea {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 600px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
  .audio-icon-div {
    background: #e4e5e7;
    width: 28px;
    border-radius: 50%;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .audio-icon-div img {
    height: 16px;
    width: 19px !important;
  }
  .recording-upload-dic {
    height: 120px;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 15px;
    border: 0.7px solid #bac0d4b2;
    padding: 20px;
  }
  .click-upload {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .click-upload span {
    color: #ed1c24;
    font-weight: 600;
  }
  .the-upload-input {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  @media (max-width: 1950px) {
    .event-slider {
      max-width: 1200px;
    }
  }
  @media (max-width: 1700px) {
    .event-slider {
      max-width: 1000px;
    }
  }
  @media (max-width: 1490px) {
    .event-slider {
      max-width: 800px;
    }
  }

  @media (max-width: 1350px) {
    .event-slider {
      max-width: 600px;
    }
  }
  @media (max-width: 1250px) {
    .the-links {
      flex-wrap: wrap;
    }
    .dash-3,
    .all-dashes {
      flex-direction: column;
    }
  }

  @media (max-width: 1250px) {
    .sub-dash-3-1 {
      width: 90vw !important;
    }
  }

  @media (max-width: 992px) {
    .sub-dash-3-1,
    .dash-4,
    .dash-5 {
      width: 90vw;
    }
  }
  @media (max-width: 700px) {
    .dash-1,
    .the-links,
    .dash-2 {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
  }
  @media (max-width: 600px) {
    .sub-dash-3-2 {
      width: 90vw;
    }
  }
`;

const EVENT_CARD_WIDTH = 229;
const EVENT_CARD_GAP = 10;
const SLIDE_WIDTH = EVENT_CARD_WIDTH + EVENT_CARD_GAP;
const SLIDE_AUTOPLAY_INTERVAL = 5000;

const events = [
  {
    title: "The Hour of Mercy",
    date: "01 March, 6:00am - 7:00am",
    bgImage: "/images/image_1.png",
  },
  {
    title: "The Hour of Mercy",
    date: "01 March, 6:00am - 7:00am",
    bgImage: "/images/image_2.png",
  },
  {
    title: "The Hour of Mercy",
    date: "01 March, 6:00am - 7:00am",
    bgImage: "/images/image_3.png",
  },
  {
    title: "The Hour of Mercy",
    date: "01 March, 6:00am - 7:00am",
    bgImage: "/images/image_1.png",
  },
  {
    title: "The Hour of Mercy",
    date: "01 March, 6:00am - 7:00am",
    bgImage: "/images/image_2.png",
  },
];
const PAGE_SIZE = 10;
const UserDashboard = () => {
  const dispatch = useDispatch();
  const {
    sheduleCategory,
    eventImages = {},
    upcomingEvents,
    imageUrl,
    eventSuccess,
    eventSuccessTwo,
    eventloading,
    loading,
    error,
  } = useSelector((state) => state.userData);
  console.log(upcomingEvents);

  const updates = [
    {
      id: 1,
      img: "",
      name: "User008",
      text: "Follwed you",
      time: "5 min ago",
    },
    {
      id: 2,
      img: "",
      name: "David001",
      text: "Liked your event",
      time: "5 min ago",
    },
    {
      id: 3,
      img: "",
      name: "EmmyWill",
      text: "Follwed you",
      time: "20 min ago",
    },
    {
      id: 4,
      img: "",
      name: "Sarah_1",
      text: "Liked your event",
      time: "10 min ago",
    },
    {
      id: 5,
      img: "",
      name: "User008",
      text: "Follwed you",
      time: "5 min ago",
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [popScheduleLates, setPopScheduleLater] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(
    "(GMT+01:00) West Central Africa"
  );

  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [selectedTime, setSelectedTime] = useState("Start Time");
  const [tempTime, setTempTime] = useState(selectedTime);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const currentMonth = new Date();
  const [upcomingPage, setUpcomingPage] = useState(1);
  const [timeMenuOpen, setTimeMenuOpen] = useState(false);

  const [chosenTime, setChosenTime] = useState("End Time");
  const channelId = localStorage.getItem("pluglrUserChannelId"); // or whatever key you're using

  const [highlightedTime, setHighlightedTime] = useState("");
  const [showCategory, setShowCategory] = useState(false);
  const [selectedOption, setSelectedOption] = useState("default");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Select Category");
  const [eventCreationError, setEventCreationError] = useState(null);
  const [uploadState, setUploadState] = useState("default"); // "default", "uploading", "success", "error"
  const [fileName, setFileName] = useState("");
  const [showAcess, setShowAccess] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState("Access type");
  const [showRecording, setShowRecording] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    channelId: channelId,
    startTime: "",
    endTime: "",
    category: "",
    description: "",
  });

  console.log(formData);

  console.log(eventSuccessTwo);
  console.log(uploadedImage);

  const getEventsPayload = (events) => events?.data || events?.events || events;

  const buildEventCards = (payload) => {
    if (!Array.isArray(payload) || payload.length === 0) {
      return [];
    }

    return payload.map((item) => {
      const id = item?.id || item?.eventId;
      const fallbackImage =
        item?.imageUrl && item.imageUrl.trim() !== ""
          ? item.imageUrl
          : item?.bgImage && item.bgImage.trim() !== ""
          ? item.bgImage
          : "/images/image_1.png";

      return {
        id,
        channelId: item?.channelId || item?.channel?.id,
        startTime: item?.startTime,
        endTime: item?.endTime,
        title: item?.title || item?.name || "Untitled event",
        text: item?.description || item?.summary || "",
        bgImage: eventImages?.[id] || fallbackImage,
        color: "#4A4A4A",
      };
    });
  };

  const upcomingEventCards = useMemo(
    () => buildEventCards(getEventsPayload(upcomingEvents)),
    [eventImages, upcomingEvents]
  );

  const sliderLength = upcomingEventCards?.length ?? 0;
  const hasSlides = sliderLength > 0;
  const hasMultipleSlides = sliderLength > 1;

  useEffect(() => {
    if (!hasSlides) {
      setCurrentIndex(0);
      return;
    }

    setCurrentIndex((prevIndex) => (prevIndex >= sliderLength ? 0 : prevIndex));
  }, [hasSlides, sliderLength]);

  const displayCards = useMemo(() => {
    if (!hasSlides) {
      return [];
    }

    if (!hasMultipleSlides) {
      return upcomingEventCards;
    }

    return [...upcomingEventCards, ...upcomingEventCards];
  }, [hasMultipleSlides, hasSlides, upcomingEventCards]);

  useEffect(() => {
    dispatch(fetchUpcomingEvents({ page: upcomingPage, pageSize: PAGE_SIZE }));
  }, [dispatch, upcomingPage]);

  useEffect(() => {
    dispatch(fetchScheduleCategory());
  }, [dispatch]);

  useEffect(() => {
    const sources = [getEventsPayload(upcomingEvents)];

    sources.forEach((payload) => {
      if (!Array.isArray(payload) || payload.length === 0) {
        return;
      }

      payload.forEach((item) => {
        const id = item?.id || item?.eventId;
        if (!id || eventImages?.[id]) {
          return;
        }

        dispatch(fetchEventImage(id));
      });
    });
  }, [dispatch, eventImages, upcomingEvents]);

  useEffect(() => {
    if (selectedTime !== "Start Time" && selectedDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = selectedTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        startTime: timestamp,
      }));
    }
  }, [selectedTime, selectedDate]);

  useEffect(() => {
    if (chosenTime !== "End Time" && selectedEndDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = chosenTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedEndDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        endTime: timestamp,
      }));
    }
  }, [chosenTime, selectedEndDate]);

  useEffect(() => {
    if (selectedCategory !== "Select Category") {
      setFormData((prev) => ({
        ...prev,
        category: selectedCategory,
      }));
    }
  }, [selectedCategory]);

  const handleShowAccess = () => {
    setShowAccess(!showAcess);
  };
  const timezones = [
    "(GMT-08:00) Pacific Time (US & Canada)",
    "(GMT-05:00) Eastern Time (US & Canada)",
    "(GMT+00:00) Greenwich Mean Time",
    "(GMT+01:00) West Central Africa",
    "(GMT+05:30) India Standard Time",
    "(GMT+08:00) Singapore Time",
  ];
  const handleShowRecording = () => {
    setShowRecording(!showRecording);
  };
  const handleShowCategory = () => {
    setShowCategory((prev) => !prev);
  };
  const handleSelectAccess = (access) => {
    setSelectedAccess(access); // Update the selected category
    setShowAccess(false); // Close the dropdown
  };
  const handleSelectCategory = (category) => {
    setSelectedCategory(category); // Update the selected category
    setShowCategory(false); // Close the dropdown
  };

  const handleTimezoneChange = (timezone) => {
    setSelectedTimezone(timezone);
    setShowDropdown(false); // Close the dropdown after selection
  };
  // Generate time options in 12-hour format
  const generateTimes = () => {
    const times = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 1) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        times.push(`${formattedHour}:${formattedMinutes} AM`);
        times.push(`${formattedHour}:${formattedMinutes} PM`);
      }
    }
    return times;
  };

  const times = generateTimes();

  const handleTimeChange = (time) => {
    setTempTime(time);
  };

  const saveTime = () => {
    setSelectedTime(tempTime);
    setShowTimeDropdown(false);
  };

  const confirmTimeSelection = () => {
    setChosenTime(highlightedTime);
    setTimeMenuOpen(false);
  };

  const daysInMonth = eachDayOfInterval({
    start: startOfMonth(currentMonth),
    end: endOfMonth(currentMonth),
  });

  const handleDateClick = (date) => {
    setSelectedDate(new Date(date));
    setShowCalendar(false);
  };

  const handleEndDateClick = (date) => {
    setSelectedEndDate(new Date(date));
    setShowEndCalendar(false);
  };

  const renderHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };

  const renderDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedDate && isSameDay(day, selectedDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleDateClick(day)}
          className={`calendar-day 
                    ${isTodayDate ? "today" : ""} 
                    ${isSelected ? "selected" : ""} 
                    ${!isCurrentMonth ? "other-month" : ""}
                `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  const renderEndHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };
  const renderEndDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedEndDate && isSameDay(day, selectedEndDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleEndDateClick(day)}
          className={`calendar-day 
                    ${isTodayDate ? "today" : ""} 
                    ${isSelected ? "selected" : ""} 
                    ${!isCurrentMonth ? "other-month" : ""}
                `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  // Function to generate times in the desired format
  const createTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minute = 0; minute < 60; minute++) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinute = minute.toString().padStart(2, "0");
        timeOptions.push(`${formattedHour}:${formattedMinute} AM`);
        timeOptions.push(`${formattedHour}:${formattedMinute} PM`);
      }
    }
    return timeOptions;
  };

  // Generate the time options
  const availableTimes = createTimeOptions();

  const updateTimeSelection = (time) => {
    setHighlightedTime(time);
  };

  const handleRadioChange = (event) => {
    const { value } = event.target;
    setSelectedOption(value);
    if (value === "default") {
      setUploadedImage(null);
      setPreviewImage(null);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const goToSlide = useCallback(
    (index) => {
      if (
        !Array.isArray(upcomingEventCards) ||
        upcomingEventCards.length === 0
      ) {
        return;
      }

      const normalizedIndex =
        ((index % upcomingEventCards.length) + upcomingEventCards.length) %
        upcomingEventCards.length;
      setCurrentIndex(normalizedIndex);
    },
    [upcomingEventCards]
  );

  const nextSlide = useCallback(() => {
    if (!Array.isArray(upcomingEventCards) || upcomingEventCards.length === 0) {
      return;
    }
    goToSlide(currentIndex + 1);
  }, [currentIndex, goToSlide, upcomingEventCards]);

  const previousSlide = useCallback(() => {
    if (!Array.isArray(upcomingEventCards) || upcomingEventCards.length === 0) {
      return;
    }
    goToSlide(currentIndex - 1);
  }, [currentIndex, goToSlide, upcomingEventCards]);

  useEffect(() => {
    if (
      !Array.isArray(upcomingEventCards) ||
      upcomingEventCards.length <= 1 ||
      isHovered
    ) {
      return undefined;
    }

    const timer = setInterval(() => {
      nextSlide();
    }, SLIDE_AUTOPLAY_INTERVAL);

    return () => clearInterval(timer);
  }, [isHovered, nextSlide, upcomingEventCards]);

  const handlePopScheduleLater = () => {
    setPopScheduleLater(!popScheduleLates);
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

  const handleCloseEventCreate = () => {
    dispatch(resetCreateEvent());
    setPopScheduleLater(false);
  };

  const getSelectedImageFile = useCallback(async () => {
    if (selectedOption === "upload" && uploadedImage) {
      return uploadedImage;
    }

    try {
      const defaultImagePath = "/images/image_1.png";
      const response = await fetch(defaultImagePath);
      if (!response.ok) {
        throw new Error(`Failed to load default image: ${response.status}`);
      }
      const blob = await response.blob();
      const fileName = defaultImagePath.split("/").pop() || "default_theme.png";
      return new File([blob], fileName, { type: blob.type || "image/png" });
    } catch (error) {
      console.error("getSelectedImageFile", error);
      return null;
    }
  }, [selectedOption, uploadedImage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEventCreationError(null);

    try {
      const createdEvent = await dispatch(createEvent(formData)).unwrap();
      const evtId = createdEvent?.data?.id;

      if (!evtId) {
        setEventCreationError("Unable to create event. Please try again.");
        return;
      }

      const imageFile = await getSelectedImageFile();
      if (!imageFile) {
        setEventCreationError("No image file available for upload");
        return;
      }

      await dispatch(
        uploadEventImage({ evt_id: evtId, file: imageFile })
      ).unwrap();

      setSelectedOption("default");
      setUploadedImage(null);
      setPreviewImage(null);
    } catch (error) {
      console.error("handleSubmit", error);
      setEventCreationError(
        error?.message ||
          error?.data?.message ||
          "Failed to create event. Please try again."
      );
    }
  };

  return (
    <DashboardRap>
      <div className="dashboard">
        <div className="dash-1">
          <div className="sub-dash-1">
            <h4>Welcome back, Olivia</h4>
            <p>Create, manage and share streaming </p>
          </div>
          <div className="the-links">
            <Link to="/liveshow" className="links live">
              <img src="/images/go-live.png" alt="" />
              Go live
            </Link>
            <Link onClick={handlePopScheduleLater} className="links schedule">
              <img src="/images/shed.png" alt="" />
              Schedule for later
            </Link>
            <Link onClick={handleShowRecording} className="links upload">
              <img src="/images/upload.png" alt="" />
              Upload recording
            </Link>
          </div>
        </div>
        <div className="dash-2">
          <div className="sub-dash-2">
            <p>Total Earnings</p>
            <h4>$200,000</h4>
          </div>
          <div className="sub-dash-2">
            <p>Total Listeners</p>
            <h4>1500K</h4>
          </div>
          <div className="sub-dash-2">
            <p>Total Streams</p>
            <h4>
              10.05K{" "}
              <span>
                <Icon
                  icon="formkit:arrowup"
                  width="12"
                  height="12"
                  style={{ color: "#027a48", cursor: "pointer" }}
                />
                100%
              </span>
            </h4>
          </div>
          <div className="sub-dash-2">
            <p>Total Followers</p>
            <h4>
              10.05K{" "}
              <span>
                <Icon
                  icon="formkit:arrowup"
                  width="12"
                  height="12"
                  style={{ color: "#027a48", cursor: "pointer" }}
                />
                100%
              </span>
            </h4>
          </div>
        </div>
        <div className="dash-3">
          <div className="sub-dash-3-1">
            <div className="month-listen-head">
              <h4>Monthly Listeners</h4>
              <img src="/images/chart-icon.png" alt="" />
            </div>
            <div style={{ height: "290px" }}>
              <MonthlyListenersChart />
            </div>
          </div>
          <div className="sub-dash-3-2">
            <div className="top-listen-head">
              <h4>Top Listeners</h4>
              <Icon
                icon="entypo:dots-three-horizontal"
                width="16"
                height="16"
                style={{ color: "#818893", cursor: "pointer" }}
              />
            </div>
            <div>
              <TopListenersChart />
            </div>
          </div>
        </div>
        <div className="all-dashes">
          <div className="dash-4">
            <div className="sub-dash-4">
              <h4>Upcoming Events</h4>
            </div>
            {hasSlides ? (
              <div
                className="event-slider"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {hasMultipleSlides && (
                  <button
                    type="button"
                    className="slider-nav prev"
                    onClick={previousSlide}
                  >
                    <Icon icon="mdi:chevron-left" width="20" height="20" />
                  </button>
                )}

                <div
                  className="event-container"
                  style={{
                    transform: `translateX(-${currentIndex * SLIDE_WIDTH}px)`,
                  }}
                >
                  {displayCards.map((event, index) => (
                    <div
                      key={`${event?.id || event?.title || index}-${index}`}
                      className="event-card"
                      style={{ backgroundImage: `url(${event.bgImage})` }}
                    >
                      <div className="event-content">
                        <h4>{event.title}</h4>
                        <p>
                          {event.startTime
                            ? new Date(event.startTime).toLocaleString()
                            : ""}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {hasMultipleSlides && (
                  <button
                    type="button"
                    className="slider-nav next"
                    onClick={nextSlide}
                  >
                    <Icon icon="mdi:chevron-right" width="20" height="20" />
                  </button>
                )}

                {hasMultipleSlides && (
                  <div className="dots-container">
                    {upcomingEventCards.map((_, index) => (
                      <span
                        key={index}
                        className={`dot ${
                          index === currentIndex ? "active" : ""
                        }`}
                        onClick={() => goToSlide(index)}
                      />
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="no-events">
                <img src="/images/no-update.png" alt="" />
                <div className="no-events-text">
                  <h4>No events!</h4>
                  <p>Upcoming events will appear here</p>
                </div>
              </div>
            )}
          </div>
          <div className="dash-5">
            {updates && updates.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th className="updatesTh">Recent Updates</th>
                    <th>
                      <Icon
                        icon="entypo:dots-three-horizontal"
                        width="16"
                        height="16"
                        style={{ color: "#818893", cursor: "pointer" }}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {updates ? (
                    updates.map((caseItem) => (
                      <tr key={caseItem.id}>
                        <td>
                          <div className="left-td">
                            <img src={caseItem.img} alt="" />
                            <div className="row-name">
                              <p className="name">{caseItem.name}</p>
                              <p className="text">{caseItem.text}</p>
                            </div>
                          </div>
                        </td>
                        <td className="time">{caseItem.time}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="no-case">
                        <img src="/images/mask_img.png" alt="" />
                        <h3>No case found.</h3>
                        <p style={{}}>
                          Stay organized by keeping every case detail in one
                          place.
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <div className="no-events">
                <img src="/images/no-update.png" alt="" />
                <div className="no-events-text">
                  <h4>No updates!</h4>
                  <p>Recent update will appear here</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        {popScheduleLates ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Schedule for later</h4>
                <Icon
                  onClick={handlePopScheduleLater}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input
                    className="schedules-inputs"
                    type="text"
                    placeholder="Event title"
                    value={formData.title} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        title: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                <div className="timezone">
                  <p>
                    Current timezone: {selectedTimezone}{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDropdown(!showDropdown);
                      }}
                    >
                      Change the zone
                    </a>
                  </p>

                  {showDropdown && (
                    <ul
                      className="timezone-dropdown"
                      style={{
                        listStyleType: "none",
                      }}
                    >
                      {timezones.map((zone, index) => (
                        <li
                          key={index}
                          onClick={() => handleTimezoneChange(zone)}
                          style={{
                            padding: "10px",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#f0f0f0")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "white")
                          }
                        >
                          {zone}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="start-date-time">
                  <div>
                    <div
                      onClick={() => setShowTimeDropdown(!showTimeDropdown)}
                      className="time-input"
                    >
                      <span>{selectedTime}</span>
                      <span></span>
                    </div>

                    {showTimeDropdown && (
                      <div className="time-dropdown">
                        <p style={{ fontWeight: "bold" }}>Select time</p>
                        <div className="time-dropdown-div">
                          {times.map((time, index) => (
                            <div
                              className="the-time"
                              key={index}
                              onClick={() => handleTimeChange(time)}
                              style={{
                                border:
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499"
                                    : "none",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border =
                                  "0.7px solid #BAC0D499")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border =
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499ue"
                                    : "none")
                              }
                            >
                              {time}
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            onClick={() => setShowTimeDropdown(false)}
                            className="time-cancel"
                          >
                            Cancel
                          </button>
                          <button onClick={saveTime} className="time-save">
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="calendar-container">
                    {/* Date Input */}
                    <input
                      type="text"
                      value={selectedDate ? format(selectedDate, "PPP") : ""}
                      placeholder="Start Date"
                      readOnly
                      onClick={() => setShowCalendar(!showCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showCalendar && (
                      <div className="calendar-dropdown">
                        {renderHeader()}
                        <div className="calendar-grid">{renderDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="start-date-time">
                  <div
                    className="event-date-time"
                    style={{ maxWidth: "344px" }}
                  >
                    {/* Time Selector */}
                    <div>
                      <div
                        onClick={() => setTimeMenuOpen(!timeMenuOpen)}
                        className="time-input"
                      >
                        <span>{chosenTime}</span>
                      </div>

                      {timeMenuOpen && (
                        <div
                          className="time-dropdown"
                          style={{
                            padding: "10px",
                            border: "0.6px solid #D0D5DD",
                          }}
                        >
                          <p style={{ fontWeight: "bold" }}>Select time</p>
                          <div
                            className="time-dropdown-div"
                            style={{ maxHeight: "150px", overflowY: "scroll" }}
                          >
                            {availableTimes.map((timeOption, index) => (
                              <div
                                className="the-time"
                                key={index}
                                onClick={() => updateTimeSelection(timeOption)}
                                style={{
                                  padding: "10px",
                                  border:
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.border =
                                    "0.7px solid #BAC0D499")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.border =
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none")
                                }
                              >
                                {timeOption}
                              </div>
                            ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              onClick={() => setTimeMenuOpen(false)}
                              className="time-cancel"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={confirmTimeSelection}
                              className="time-save"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="calendar-container">
                    {/* Date Input */}
                    <input
                      type="text"
                      value={
                        selectedEndDate ? format(selectedEndDate, "PPP") : ""
                      }
                      placeholder="End Date"
                      readOnly
                      onClick={() => setShowEndCalendar(!showEndCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showEndCalendar && (
                      <div className="calendar-dropdown">
                        {renderEndHeader()}
                        <div className="calendar-grid">{renderEndDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="category">
                  <div onClick={handleShowCategory} className="category-input">
                    <p>{selectedCategory}</p>{" "}
                    {/* Display the selected category */}
                  </div>
                  {showCategory && (
                    <div className="category-dropdown">
                      {JSON.parse(sheduleCategory?.data).map(
                        (category, index) => (
                          <p
                            key={index}
                            onClick={() => handleSelectCategory(category)}
                          >
                            {category}
                          </p>
                        )
                      )}
                    </div>
                  )}
                </div>
                <div>
                  <textarea
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                    value={formData.description} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        description: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png"
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={previewImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button onClick={handleSubmit} className="schedule-btn">
                  {eventloading ? (
                    <ClipLoader color="white" size={40} />
                  ) : (
                    "Schedule event"
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        {showRecording ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Upload recordings</h4>
                <Icon
                  onClick={handleShowRecording}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input type="text" placeholder="Recording title" />
                </div>
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="recording-upload-dic"
                >
                  {uploadState === "default" && (
                    <>
                      <input
                        type="file"
                        accept=".mp4"
                        onChange={handleFileUpload}
                        style={{ display: "none" }}
                        id="file-upload"
                      />
                      <label
                        htmlFor="file-upload"
                        style={{ cursor: "pointer" }}
                        className="the-upload-input"
                      >
                        <div className="audio-icon-div">
                          <img src="/images/audio-icon.png" alt="audio wave" />
                        </div>
                        <p className="click-upload">
                          <span>Click to upload </span>
                          or drag and drop
                        </p>

                        <p className="click-upload">
                          MP4 only (max size: 800x400px)
                        </p>
                      </label>
                    </>
                  )}

                  {uploadState === "uploading" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p>{fileName}</p>
                      <p>200 KB - 100% uploading</p>
                    </div>
                  )}

                  {uploadState === "success" && (
                    <div>
                      <p>File uploaded successfully!</p>
                      <p>{fileName}</p>
                    </div>
                  )}

                  {uploadState === "error" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p style={{ color: "red" }}>
                        Upload failed, please{" "}
                        <span style={{ textDecoration: "underline" }}>
                          Try again
                        </span>
                      </p>
                      <p>{fileName}</p>
                    </div>
                  )}
                </div>
                <div className="category">
                  <div onClick={handleShowAccess} className="category-input">
                    <p>{selectedAccess}</p>{" "}
                    {/* Display the selected category */}
                  </div>
                  {showAcess && (
                    <div className="category-dropdown">
                      <p onClick={() => handleSelectAccess("Public")}>Public</p>
                      <p onClick={() => handleSelectAccess("Only me")}>
                        Only me
                      </p>
                      <p onClick={() => handleSelectAccess("Unlisted")}>
                        Unlisted
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <input
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png" // Replace with your default image URL
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button className="schedule-btn">Schedule event</button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {eventSuccess ? (
        <div className="dropdown-container">
          <div className="all-dropdown-div">
            <div className="dropdown-div">
              <p
                style={{
                  margin: "auto",
                  fontSize: "20px",
                  maxWidth: "300px",
                  fontWeight: "600",
                  paddingBottom: "30px",
                }}
              >
                {eventSuccess?.message}
              </p>
              <button onClick={handleCloseEventCreate} className="schedule-btn">
                CLOSE
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {eventCreationError && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "16px",
              width: "400px",
              maxWidth: "90%",
              padding: "30px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Icon icon="mdi:alert-circle" width="40" height="40" />
            </div>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "600",
                color: "#060b13",
                margin: 0,
              }}
            >
              Error
            </h3>
            <p
              style={{
                fontSize: "16px",
                color: "#475467",
                lineHeight: "1.5",
                margin: 0,
              }}
            >
              {eventCreationError}
            </p>
            <button
              onClick={() => setEventCreationError(null)}
              style={{
                background: "#ed1c24",
                color: "white",
                border: "none",
                padding: "12px 30px",
                borderRadius: "100px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </DashboardRap>
  );
};

export default UserDashboard;
